export const getAge = (date: Date) => {
  const years = (new Date().getTime() - date.getTime()) / 3.15576e10;
  if (years > 1) {
    return `${Math.floor(years)} jaar`;
  } else {
    const months = Math.max(1, Math.floor(years * 12));
    return `${months} ${months > 1 ? 'maanden' : 'maand'}`;
  }
};

export const getStarsign = (date: Date, locale: 'nl' | 'en' = 'nl') => {
  const days = [21, 20, 21, 21, 22, 22, 23, 24, 24, 24, 23, 22];
  if (!['nl', 'en'].includes(locale)) locale = 'nl';
  const signs = {
    en: [
      'Aquarius',
      'Pisces',
      'Aries',
      'Taurus',
      'Gemini',
      'Cancer',
      'Leo',
      'Virgo',
      'Libra',
      'Scorpio',
      'Sagittarius',
      'Capricorn',
    ],
    nl: [
      'Waterman',
      'Vissen',
      'Ram',
      'Stier',
      'Tweelingen',
      'Kreeft',
      'Leeuw',
      'Maagd',
      'Weegschaal',
      'Schorpioen',
      'Boogschutter',
      'Steenbok',
    ],
  };

  let month = date.getMonth();
  const day = date.getDate();
  if (month == 0 && day <= 20) {
    month = 11;
  } else if (day < days[month]) {
    month--;
  }
  return signs[locale][month];
};

export const themes = {
  dinosaur: {
    image1: '/assets/dino1.png',
    image2: '/assets/dino2.png',
    image3: '/assets/dino3.jpg',
  },
  princesses: {
    image1: '/assets/pricess1.png',
    image2: '/assets/pricess2.png',
    image3: '/assets/pricess3.png',
  },
  universe: {
    image1: '/assets/universe1.png',
    image2: '/assets/universe2.png',
    image3: '/assets/universe3.jpg',
  },
  marvel: {
    image1: '/assets/marvel1.png',
    image2: '/assets/marvel2.png',
    image3: '/assets/marvel3.jpg',
  },
  animals: {
    image1: '/assets/animal1.png',
    image2: '/assets/animal2.png',
    image3: '/assets/animal3.jpg',
  },
  mariokart: {
    image1: '/assets/mariokart1.png',
    image2: '/assets/mariokart2.png',
    image3: '/assets/mariokart3.jpg',
  },
};
